import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'react-bootstrap';
import BidsSearch from './search/BidsSearch';
import BidsStatusFilter from './BidsStatusFilter';
import BidsTable from './table/BidsTable';
import { setQueryString, useQueryString } from '../common/helpers/queryString';
import { searchBids } from './BidsActions';
import CommonLoader from '../common/components/CommonLoader';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import { SSEClient } from '../api/SSEClient';
import { getDealer } from '../dealers/DealersActions';

const sseClient = new SSEClient();

function BidsPage() {
  const dispatch = useDispatch();
  const query = useQueryString();
  const location = useLocation();
  const navigate = useNavigate();
  const { dealerId } = useParams();

  const previousSearchParams = useSelector((state) => state.bids.get('bidsSearchParams'));
  const items = useSelector((state) => state.bids.get('items'));
  const totalItems = useSelector((state) => state.bids.get('totalItems'));
  const dealerDetails = useSelector((state) => state.dealers.get('dealerDetails'));

  const [dealerName, setDealerName] = useState(null);

  const initialSearchParams = {
    offset: query.get('page') ? +query.get('page') - 1 : 0,
    bidderOrganizationId: dealerId || null,
  };

  const [searchParams, setSearchParams] = useState(
    previousSearchParams || initialSearchParams,
  );

  useEffect(() => {
    sseClient.listen(() => {
      dispatch(searchBids(searchParams, false));
    });
    return () => {
      sseClient.close();
    };
  }, [searchParams]);

  useEffect(() => {
    if (dealerId) {
      dispatch(getDealer(dealerId));
    } else {
      setDealerName(null);
    }
  }, [dispatch, dealerId]);

  useEffect(() => {
    if (dealerId && dealerDetails?.organization) {
      setDealerName(dealerDetails.organization.officialCompanyName || '');
    }
  }, [dealerDetails, dealerId]);

  useEffect(() => {
    dispatch(searchBids(searchParams));
  }, [dispatch, searchParams]);

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({ ...prevState, offset: value }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  const handleSearch = (values, setSubmitting) => {
    setSearchParams((prevState) => ({ ...prevState, ...values, offset: 0 }));
    setSubmitting(false);
  };

  const handleChangeStatus = (status) => {
    setSearchParams((prevState) => ({
      ...prevState,
      status,
      offset: 0,
    }));
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'span', text: 'Bids' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Bids" />
      {items ? (
        <>
          <BidsSearch onSearch={handleSearch} dealerName={dealerName} />
          <BidsStatusFilter onChangeStatus={handleChangeStatus} />
          <BidsTable
            searchParams={searchParams}
            changeOffset={changeOffset}
            offset={searchParams.offset}
            data={{ items, total: totalItems }}
          />
        </>
      ) : (
        <CommonLoader />
      )}
    </Container>
  );
}

export default BidsPage;
